import { Body, Heading } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export type Testimonial = {
  quote: string;
  author: string;
  sellerId: string;
};

interface TestimonialItemProps {
  testimonial: Testimonial;
}

export default function TestimonialItem({ testimonial }: TestimonialItemProps) {
  const { quote, author } = testimonial;

  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  function handleShopLinkClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.USER_INTERACTION_ACTION, {
      interactionType: 'ViewShop',
      userId: testimonial.sellerId,
    });
  }

  return (
    <article className={styles.testimonial}>
      <header>
        <cite>
          <ExtendedLink
            href={`/${author}/`}
            className={styles.author}
            aria-label={`View ${author}'s profile`}
            onClick={handleShopLinkClick}
          >
            <Heading variant="md" as="span">
              @{author}
            </Heading>
          </ExtendedLink>
        </cite>
      </header>
      <blockquote>
        <Body variant="sm-regular">{quote}</Body>
      </blockquote>
    </article>
  );
}
